// extracted by mini-css-extract-plugin
export default {"page-noti":"notification_page-noti__ZJZSX","title":"notification_title__rqlT4"};